"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPermissionsDto = instanceOfPermissionsDto;
exports.PermissionsDtoFromJSON = PermissionsDtoFromJSON;
exports.PermissionsDtoFromJSONTyped = PermissionsDtoFromJSONTyped;
exports.PermissionsDtoToJSON = PermissionsDtoToJSON;
exports.PermissionsDtoToJSONTyped = PermissionsDtoToJSONTyped;
const Permissions_1 = require("./Permissions");
/**
 * Check if a given object implements the PermissionsDto interface.
 */
function instanceOfPermissionsDto(value) {
    if (!('permissions' in value) || value['permissions'] === undefined)
        return false;
    return true;
}
function PermissionsDtoFromJSON(json) {
    return PermissionsDtoFromJSONTyped(json, false);
}
function PermissionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'permissions': (json['permissions'].map(Permissions_1.PermissionsFromJSON)),
    };
}
function PermissionsDtoToJSON(json) {
    return PermissionsDtoToJSONTyped(json, false);
}
function PermissionsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'permissions': (value['permissions'].map(Permissions_1.PermissionsToJSON)),
    };
}
//# sourceMappingURL=PermissionsDto.js.map